import Verificado from "./assets/Verificado.svg";
import BannerVerify from "./assets/banner-verify.svg";
import BannerMobile from "./assets/banner_mobile.svg";
import InicLogo from "./assets/inic_logo.svg";

const branding = {
  pageTitle: "GovVerificaSTP",
  referenceIdLabel: "Reference ID",
  verificationMark: Verificado,
  portalBanner: Verificado,
  portalBannerMobile: BannerMobile,
  credentialInfoImage: BannerVerify,
  inicLogo: InicLogo,
  overlayHeroCopy: true,
  preferLocalHeroBanners: true,
  contact: {
    email: "support@gov.st",
    phone: "+239 222 22 22",
    address: "São Tomé, São Tomé and Príncipe",
  },
};

export default branding;
